const autocompleteFormParamEquipModel = {
  serviceTypes: 'Tipo de servicio',
  frequency: 'Periodicidad',
  groups: 'Grupo',
};

export default autocompleteFormParamEquipModel;
